'use client';

import s from './TinySectionTitle.module.scss';
import { useEffect, useRef } from 'react';
import { gsap } from '@/lib/gsapSetup';

const TinySectionTitle = ({
  tag = 'span',
  text,
  immediatelyAnimate = true,
  className = '',
}) => {
  const dotRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const text = textRef.current;

    if (dot && text) {
      const animation = {
        dot: {
          from: { scale: 0, opacity: 0 },
          to: {
            scale: 1,
            opacity: 1,
            duration: 0.5,
            ease: 'elastic.out(1, 0.5)',
          },
        },
        text: {
          from: { opacity: 0, x: -10 },
          to: { opacity: 1, x: 0, duration: 0.5, ease: 'power2.out' },
        },
      };

      if (immediatelyAnimate) {
        gsap.fromTo(dot, animation.dot.from, animation.dot.to);
        gsap.fromTo(text, animation.text.from, {
          ...animation.text.to,
          delay: 0.5,
        });
      } else {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: text,
            start: 'top center',
            toggleActions: 'play none none reverse',
          },
        });
        tl.fromTo(dot, animation.dot.from, animation.dot.to).fromTo(
          text,
          animation.text.from,
          animation.text.to,
          '-=0.3'
        );
      }
    }
  }, []);

  if (!text) return null;
  const Tag = tag;

  return (
    <Tag className={`${s.tinySectionTitle} ${className} subheading`}>
      <span ref={dotRef} className={s.dot}></span>
      <span ref={textRef} className="textGrey">
        {text}
      </span>
    </Tag>
  );
};

export default TinySectionTitle;
